export default __webpack_public_path__ + "static/media/Redressed.f792d393.ttf";